import React, { useEffect, useState } from "react";
import ProfileDropdown from "../ProfileDropdown";
import LanguageDropdown from "../LanguageDropdown";
import { BellIcon } from "./NavbarIcons";

const authButtonClass =
  "text-white font-medium hover:bg-[#575757] px-4 py-2 rounded text-left whitespace-nowrap";

function DesktopNavbarAuth({
  t,
  isLoggedIn,
  isAuthLoading,
  profilePictureUrl,
  userName,
  openRegisterModal,
  handleGoToCreateBook,
  openLoginModal,
  unreadCount,
  handleNotificationsClick,
}) {
  const [isShaking, setIsShaking] = useState(false);

  useEffect(() => {
    if (unreadCount > 0) {
      setIsShaking(true);
      const timer = setTimeout(() => setIsShaking(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [unreadCount]);

  const notificationButton = (
    <button
      type="button"
      className={`relative flex h-10 w-10 shrink-0 items-center justify-center rounded transition-transform hover:bg-[#575757] ${
        isShaking ? "animate-shake" : ""
      }`}
      onClick={handleNotificationsClick}
      aria-label={t("notifications")}
    >
      <BellIcon className="h-5 w-5 text-[#AAA]" />
      {unreadCount > 0 && (
        <span className="absolute right-0 top-0 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] leading-none text-white">
          {unreadCount}
        </span>
      )}
    </button>
  );

  return (
    <div className="ml-6 flex min-w-[308px] shrink-0 items-center justify-end">
      {isAuthLoading ? (
        <div className="flex h-10 items-center justify-end gap-2" aria-hidden="true">
          <div className="h-8 w-[76px] animate-pulse rounded bg-[#2A2A2A]" />
          <div className="h-8 w-[112px] animate-pulse rounded bg-[#2A2A2A]" />
          <div className="h-8 w-[56px] animate-pulse rounded bg-[#2A2A2A]" />
        </div>
      ) : isLoggedIn ? (
        <div className="flex h-10 items-center justify-end gap-2">
          <button
            type="button"
            className={`${authButtonClass} shrink-0`}
            onClick={handleGoToCreateBook}
          >
            {t("createBook")}
          </button>

          {notificationButton}

          <div className="flex h-10 w-10 shrink-0 items-center justify-center">
            <ProfileDropdown
              avatarUrl={profilePictureUrl ? `${profilePictureUrl}${profilePictureUrl.includes("?") ? "&" : "?"}ts=${Date.now()}` : undefined}
              userName={userName}
            />
          </div>
        </div>
      ) : (
        <div className="flex h-10 items-center justify-end gap-2">
          <div className="flex h-10 shrink-0 items-center">
            <LanguageDropdown />
          </div>
          <button type="button" className={authButtonClass} onClick={openRegisterModal}>
            {t("navbar.register")}
          </button>
          <button type="button" className={authButtonClass} onClick={openLoginModal}>
            {t("navbar.login")}
          </button>
        </div>
      )}
    </div>
  );
}

export default DesktopNavbarAuth;
